<template>
    <div>

      <z-container>
        <h3 class="text-body-1 mb-3">{{ tituloTela }}</h3>

          <v-card class="mb-3">
            <v-card-title class="text-subtitle-2">
              Fornecedor
            </v-card-title>
            <v-divider></v-divider>

            <v-card-text class="py-2">
              <v-row dense>
                <v-col sm="3">
                  <v-text-field filled dense label="Código Fornecedor" v-model="pagamentosStore.fornecedor.id" hide-details readonly></v-text-field>
                </v-col>
                <v-col sm="6">
                  <v-text-field filled dense label="Nome" v-model="pagamentosStore.fornecedor.razao" hide-details readonly></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-text-field filled dense label="Celular" v-model="pagamentosStore.fornecedor.celular" hide-details readonly></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>
            
            <v-card-actions class="px-4">
              <v-btn color="primary" depressed @click="$refs.dialogoBuscarFornecedor.abrir()">
                <v-icon left>mdi-magnify</v-icon>
                Selecionar Fornecedor
              </v-btn>
            </v-card-actions>
          </v-card>

          <z-empty-state 
            title="Nenhum fornecedor selecionado" 
            text="Selecione um fornecedor para continuar"  
            icon="mdi-account-search" 
            iconColor="primary"
            v-if="!pagamentosStore.fornecedor.id"
          >
            <!-- <template #actions>
              <v-btn color="primary" @click="$refs.dialogoBuscarFornecedor.abrir()">Selecionar Fornecedor</v-btn>
            </template> -->
          </z-empty-state>


          <v-card v-else tile :loading="$store.state.loading">
            <v-tabs v-model="tab" color="primary" @change="onTabChange">
              <v-tab :key="0">Contas a Pagar</v-tab>
              <v-tab :key="1">Pagamentos</v-tab>
              <v-tab :key="2">Whatsapp</v-tab>
              <v-tabs-slider color="primary"></v-tabs-slider>
            </v-tabs>

            <v-divider></v-divider>

            <v-tabs-items v-model="tab" touchless style="min-height: 400px;">

              <v-tab-item :key="0" :disabled="!fornecedor.id" v-bind="$v.TABS_CONFIG">

                <v-toolbar flat color="white" dense>
                  <v-btn-toggle :value="pagamentosStore.btnStatus.contaspagar" mandatory @change="filtrarContasPagar">
                    <v-btn value="todos" text small>
                      Todas
                    </v-btn>
                    <v-btn value="abertos" text small>
                      Em Aberto
                    </v-btn>
                    <v-btn value="pagos" text small>
                      Pagas
                    </v-btn>
                  </v-btn-toggle>
                  
                  <v-btn icon @click="carregarContasPagar" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                  
                  <v-spacer></v-spacer>
                  <!-- <div class="d-flex flex-row align-center" v-if="selected.length > 0">
                    <span class="mr-3">Total: {{ total_selecionado | valorBR }}</span>
                    <v-btn depressed small color="primary">Receber</v-btn>
                    <v-btn text small >Cancelar</v-btn>
                    <v-divider vertical inset class="mx-4"></v-divider>
                  </div> -->
                  
                  <!-- <v-btn depressed small color="primary" @click="adicionarPromissoriaAvulsa">Nova Conta a Pagar</v-btn> -->
                  <div style="width: 200px;" class="ml-5 mr-3">
                    <v-text-field v-model="search.promissorias" filled autofocus clearable prepend-inner-icon="search" placeholder="Documento" single-line hide-details outlined dense></v-text-field>
                  </div>

                </v-toolbar>

                <v-divider></v-divider>

                <v-card flat>
                  <v-card-title class="d-flex text-body-2 font-weight-black">
                    Contas a Pagar: {{ pagamentosStore.extrato.contaspagar.length }}

                  <!-- <v-spacer></v-spacer>
                  <div class="d-flex flex-row align-center" v-if="selected.length > 0">
                    <span class="mr-3">Total: {{ total_selecionado | valorBR }}</span>
                    <v-btn depressed small color="primary" @click="dar_baixa">Receber</v-btn>
                    <v-btn text small @click="cancelarSelecionados">Cancelar</v-btn>
                  </div> -->

                  </v-card-title>
                  <v-card-text>


                    <v-data-table 
                      v-model="selected"
                      id="contaspagar" 
                      item-key="id" 
                      :items="pagamentosStore.extrato.contaspagar"
                      :headers="headers.contaspagar"
                      :loading="false"
                      :search="search.contaspagar"
                      :show-select="pagamentosStore.btnStatus.contaspagar == 'abertos'"
                      hide-default-footer
                      disable-pagination
                      disable-sort
                    >
                      <template v-slot:item="props">
                        <tr :active="props.isSelected" style="cursor: pointer" @click="selecionarDocumento(props)">
                          <td v-show="pagamentosStore.btnStatus.contaspagar == 'abertos'">
                            <v-simple-checkbox :value="props.isSelected" @input="props.select(!props.isSelected)" color="primary"></v-simple-checkbox>
                          </td>
                          <td class="text-no-wrap">
                            <router-link v-if="props.item.movimento_id" @click.native.stop target="_blank" :to="{ name: 'EstoqueVisualizar', params: { id: props.item.movimento_id }, query: { tab: 'contas' } }">{{ props.item.documento }}</router-link>
                            <span v-else>{{ props.item.documento }}</span>
                          </td>
                          <td>{{ props.item.forma_pagamento}}</td>
                          <td>{{ props.item.vencimento | dataBR}}</td>
                          <td class="text-right">{{ props.item.valor | valorBR}}</td>
                          <td class="text-right">{{ props.item.valor_pago | valorBR}}</td>
                          <td class="text-right"><b>{{ props.item.valor_restante | valorBR}}</b></td>
                          <td class="text-center text-no-wrap">
                            <v-tooltip top v-if="!props.item.movimento_id && props.item.valor_pago == 0">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="ma-0" @click.stop="excluir(props.item)">
                                  <v-icon>delete</v-icon>
                                </v-btn>
                              </template>
                              <span>Excluir</span>
                            </v-tooltip>
                            <v-tooltip top v-if="props.item.valor_pago > 0">
                              <template v-slot:activator="{ on }">
                                <v-btn v-on="on" icon class="ma-0" @click.stop="exibirPagamentos(props.item)">
                                  <v-icon>mdi-eye</v-icon>
                                </v-btn>
                              </template>
                              <span>Visualizar Pagamentos</span>
                            </v-tooltip>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card-text>
                </v-card>
              </v-tab-item>


              <v-tab-item :key="1" v-bind="$v.TABS_CONFIG">
                <v-toolbar flat color="white" dense>
                  <div style="width: 250px;">
                    <v-text-field v-model="search.recebimentos" autofocus clearable prepend-inner-icon="search" placeholder="Número do Pagamento" single-line hide-details outlined dense filled></v-text-field>
                  </div>

                  <v-btn icon @click="carregarPagamentos" :loading="$store.state.loading">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-divider></v-divider>
                
                <!-- <v-alert icon="mdi-information" class="my-3 mx-5" color="grey" outlined text>
                  Clique no pagamento abaixo para visualizar os documentos pagos.
                </v-alert>
                
                <v-divider></v-divider> -->

                <v-card flat>
                  <v-card-text>

                    <div class="text--primary font-weight-black">Pagamentos: {{ pagamentosStore.extrato.pagamentos.length }}</div>

                    <v-data-table 
                      ref="recebimentos" 
                      :headers="headers.pagamentos" 
                      :items="pagamentosStore.extrato.pagamentos" 
                      :search="search.recebimentos" 
                      :loading="false"   
                      :single-expand="true"
                    >
                      <template v-slot:item="props">
                        <tr :active="props.item.id == selecionado.id" @click.stop="selecionar(props.item); props.expand(!props.isExpanded)" style="cursor: pointer">
                          <td>
                            <v-btn icon small class="expanded-icon">
                              <v-icon v-show="props.isExpanded">mdi-chevron-up</v-icon>
                              <v-icon v-show="!props.isExpanded">mdi-chevron-down</v-icon>
                            </v-btn>
                          </td>
                          <td>{{ props.item.id }}</td>
                          <td>{{ props.item.data | dataBR }}</td>
                          <td class="text-right">{{ props.item.total | valorBR }}</td>
                          <td class="text-center">{{ props.item.qtd_documentos }}</td>
                          <td class="text-right" style="white-space: nowrap">
                            <v-btn icon @click.stop="imprimirRecibo(props.item.id)" class="ma-0">
                              <v-icon>print</v-icon>
                            </v-btn>
                            <v-btn icon @click.stop="perguntarCancelarPagamento(props.item)" class="ma-0">
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>

                      <template v-slot:expanded-item="{ item }">
                        <tr>
                          <td colspan="6" class="px-0">
                            <v-card>
                              <v-card-text class="px-0">
                                
                                <v-card tile flat>
                                  <v-tabs v-model="tab_pagamentos" color="primary" background-color="primary" dark>
                                    <v-tab :key="0">Documentos Pagos</v-tab>
                                    <v-tab :key="1">Formas de Pagamento</v-tab>
                                  </v-tabs>
                                  
                                  <v-tabs-slider color="white"></v-tabs-slider>
                                  
                                  <v-divider></v-divider>

                                  <v-tabs-items v-model="tab_pagamentos" touchless>
                                    <v-tab-item :key="0" v-bind="$v.TABS_CONFIG">
                                      <v-data-table 
                                        ref="documentos" 
                                        no-data-text="Carregando..." 
                                        :headers="headers.documentos" 
                                        :items="pagamentosStore.extrato.documentos.documentos" 
                                        :loading="loadingdocs" 
                                        hide-default-footer
                                      >
                                        <v-progress-linear slot="progress" color="primary" height="2" indeterminate></v-progress-linear>
                                        <template v-slot:item="props">
                                          <tr>
                                            <td>{{ props.item.documento }}</td>
                                            <td class="text-center">{{ props.item.contapagar.vencimento | dataBR }}</td>
                                            <td class="text-right">{{ props.item.valor_original | valorBR }}</td>
                                            <td class="text-right font-weight-bold">{{ props.item.valor_pago | valorBR }}</td>
                                            <td class="text-right">{{ props.item.valor_restante | valorBR }}</td>
                                            <td class="text-center">
                                              <v-tooltip bottom v-show="props.item.valor_pago > 0">
                                                <template v-slot:activator="{ on }">
                                                  <v-btn v-on="on" icon class="ma-0" @click.stop="exibirPagamentos(props.item)">
                                                    <v-icon>visibility</v-icon>
                                                  </v-btn>
                                                </template>
                                                <span>Histórico de Pagamentos</span>
                                              </v-tooltip>
                                            </td>
                                          </tr>
                                        </template>
                                        <template v-slot:body.append="{ headers }">
                                          <tr>
                                            <td colspan="4" class="text-right font-weight-bold">
                                              {{ total_documentos | valorBR }}
                                            </td>
                                            <td colspan="2"></td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-tab-item>

                                    <v-tab-item :key="1" v-bind="$v.TABS_CONFIG">
                                      <v-data-table 
                                        ref="valores" 
                                        :headers="headers.valores" 
                                        :items="pagamentosStore.extrato.documentos.valores" 
                                        :loading="loadingdocs" 
                                        hide-default-footer
                                      >
                                        <v-progress-linear slot="progress" color="primary" height="2" indeterminate></v-progress-linear>
                                        <template v-slot:item="props">
                                          <tr>
                                            <td>{{ props.item.forma_pagamento }}</td>
                                            <td class="text-right">{{ props.item.valor | valorBR }}</td>
                                          </tr>
                                        </template>
                                      </v-data-table>
                                    </v-tab-item>
                                  </v-tabs-items>
                                  
                                </v-card>

                              </v-card-text>
                            </v-card>
                          </td>
                        </tr>
                      </template>

                    </v-data-table>

                  </v-card-text>
                </v-card>

              </v-tab-item>


              <v-tab-item :key="2" v-bind="$v.TABS_CONFIG">
                <CompartilharContasHistorico :fixedHeader="false"></CompartilharContasHistorico>
              </v-tab-item>

            </v-tabs-items>
            
          </v-card>
      </z-container>

      <z-dialogo ref="dialogoCancelarRecebimento" titulo="Deseja realmente cancelar esse recebimento?" :dividers="true" largura="500px">
        <div slot="texto">
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Data</v-list-item-subtitle>
                <v-list-item-title>{{ pagamento.data | dataBR}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Documentos</v-list-item-subtitle>
                <v-list-item-title>{{ pagamento.qtd_documentos }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>Valor Recebido</v-list-item-subtitle>
                <v-list-item-title>{{ pagamento.total | valorBR }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        
        </div>

        <v-btn text @click="$refs.dialogoCancelarRecebimento.fechar()" :disabled="cancelando">Cancelar</v-btn>
        <v-btn color="red darken-1" text @click="confirmarCancelarRecebimento" :loading="cancelando" :disabled="cancelando">Confirmar</v-btn>
      </z-dialogo>

      <z-dialogo-sim-nao ref="dialogoCancelarPagamento" titulo="Remover pagamento?" botaoSim="Remover" botaoNao="Cancelar">
        O pagamento <b>{{pagamento.id}}</b> no valor de <b>R$ {{pagamento.total | valorBR}}</b> com <b>{{pagamento.qtd_documentos}}</b> documento(s) será removido.
      </z-dialogo-sim-nao>

      <z-dialogo-sim-nao ref="dialogoRemoverPromissoria" titulo="Remover promissória?" botaoSim="Remover" botaoNao="Cancelar">
        A promissória será removida.
      </z-dialogo-sim-nao>

      <z-dialogo 
        ref="dialogoPromissoria" 
        titulo="Nova Promissória" 
        largura="750px" 
        eager
        :dividers="true" 
      >
        <template v-slot:texto>

          <v-form ref="form_promissoria" v-model="form_valido" lazy-validation>

              <v-row dense>
                <v-col sm="3">
                  <v-text-field ref="documento" v-model="promissoria.documento" placeholder=" " label="Documento" :rules="regras.documento" autofocus filled dense></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-select v-model="promissoria.forma_pagamento" label="Forma de Pagamento" :items="$globals.FORMAS_DE_PAGAMENTO" filled dense></v-select>
                </v-col>
                <v-col sm="3">
                  <z-date-picker-menu v-model="promissoria.vencimento" placeholder=" " label="Vencimento" filled dense></z-date-picker-menu>
                </v-col>
                <v-col sm="3">
                  <z-campo-valor v-model="promissoria.valor" placeholder=" " label="Valor" :rules="regras.valor" ref="valor" filled dense></z-campo-valor>
                </v-col>
              </v-row>

              <v-row dense>
                <v-col sm="12">
                  <v-textarea label="Observações" placeholder="Observações" v-model="promissoria.observacoes" filled dense></v-textarea>
                </v-col>
              </v-row>
              
          </v-form>

        </template>

        <v-btn text @click="$refs.dialogoPromissoria.fechar()" :disabled="salvando">Cancelar</v-btn>
        <v-btn color="primary" depressed @click="confirmarPromissoria" :loading="salvando" :disabled="salvando || !form_valido">Adicionar</v-btn>

      </z-dialogo>

      <historico-pagamento ref="dialogoExibirPagamentos"></historico-pagamento>

      <!-- <v-container> -->
        
      <v-slide-y-reverse-transition>
        <v-card class="elevation-10" width="300px" style="position: fixed; right: 10px; bottom: 10px;" v-show="selected.length > 0 && tab == 0">
          <v-card-title class="" :style="[styleCardTotal]">
            <div class="white--text">
              <div><b>Total Selecionado ({{ selected.length }})</b></div>
              <h3 class="headline mb-0">R$ {{ selected.reduce((soma, item) => soma + Number(item.valor_restante), 0) | valorBR}}</h3>
            </div>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-actions color="white" class="d-flex flex-row justify-space-between">
            <v-btn depressed color="primary" class="flex-grow-1" @click="dar_baixa">Dar Baixa</v-btn>
            <v-btn text color="grey" class="flex-grow-1" @click="cancelarSelecionados">Cancelar</v-btn>
          </v-card-actions>
        </v-card>
      </v-slide-y-reverse-transition>
      <!-- </v-container> -->

      <DialogoBuscarFornecedor ref="dialogoBuscarFornecedor" @selecionar:fornecedor="selecionarFornecedor"></DialogoBuscarFornecedor>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapState } from "vuex";
import HistoricoPagamento from "./HistoricoPagamentoFornecedor.vue";
import DialogoBuscarFornecedor from "@/components/buscas/DialogoBuscarFornecedor.vue";
import CompartilharContasHistorico from '@/pages/contaspagar/CompartilharContaHistorico.vue';
import queryBuilder from '@/app/helpers/QueryBuilder';
import { useListasStore } from '@/app/store/pinia/listas.js';


import config from '@/app/config';
import * as types from '@/app/store/mutation_types';
import { useContasPagarStore } from "@/app/store/pinia/contaspagar";
import { usePagamentosStore } from "@/app/store/pinia/pagamentos";

export default {
  name: 'extrato-fornecedor',

  components: {
    HistoricoPagamento,
    DialogoBuscarFornecedor,
    CompartilharContasHistorico
  },

  data() {
    return {
      fornecedor: {
        id: null,
        razao: '',
        celular: ''
      },
      search: {
        promissorias: '',
      },
      headers: {
        contaspagar: [
          { text: 'Documento', value: 'documento'},
          { text: 'Forma Pagamento', value: 'forma_pagamento' , width: '200px'},
          { text: 'Vencimento', value: 'vencimento', width: '120px'},
          { text: 'Valor', value: 'valor', align: 'right', width: '100px'},
          { text: 'Valor Pago', value: 'valor_pago', align: 'right', width: '130px'},
          { text: 'Restante', value: 'valor_restante', align: 'right', width: '100px'},
          { text: 'Opções', value:'', width: '80px', align: 'center', sortable: false }
        ],
        pagamentos: [
          { text: '', value: '', sortable: false, width: '50px'},
          { text: 'Número', value: 'id', sortable: false},
          { text: 'Data', value: 'data', sortable: false},
          { text: 'Total', value: 'total', align: 'right', sortable: false },
          { text: 'Docs', value: 'documentos', align: 'center', sortable: false },
          { text: 'Opções', value: '', align: 'right', sortable: false }
        ],
        documentos: [
          { text: 'Documento', value: 'documento', sortable: false },
          { text: 'Vencimento', value: 'vencimento', align: 'center', sortable: false },
          { text: 'Valor Original', value: 'valor_original', align: 'right', sortable: false },
          { text: 'Valor Pago', value: 'valor_pago', align: 'right', sortable: false },
          { text: 'Valor Restante', value: 'valor_restante', align: 'right', sortable: false },
          { text: 'Histórico', value: '', align: 'center', sortable: false }
        ],
        valores: [
          { text: 'Forma de Pagamento', value: 'forma_pagamento', sortable: false },
          { text: 'Valor', value: 'valor', align: 'right', sortable: false },
        ]
      },

      tab: 0,
      tab_pagamentos: 0,
      loading: false,
      loadingdocs: false,
      cancelando: false,
      salvando: false,
      selected: [],
      selecionado: {},
      pagamento: {},
      promissoria: {
        cliente_id: null,
        documento: '',
        forma_pagamento: '',
        vencimento: '',
        valor: '',
        valor_pago: '',
        valor_restante: '',
        observacao: ''
      },
      form_valido: true,
      regras: {
        documento: [v => !!v || 'Documento é obrigatório'],
        valor: [v => v != '0,00'   || 'Valor é obrigatório']
      },
      contasPagarStore: useContasPagarStore(),
      pagamentosStore: usePagamentosStore(),
      listasStore: useListasStore(),
    }
  },

  inject: ['$imprimir'],

  computed: {
    contaspagar() {
      return this.contasPagarStore.contaspagar;
    },
    contas_selecionadas() {
      return this.contasPagarStore.contas_selecionadas;
    },
    ...mapState('financeiro', ['pedidos', 'promissorias', 'cheques', 'recebimentos', 'documentos', 'valores', 'cliente_selecionado']),
    ...mapState('clientes', {
        cliente: 'cliente'
    }),
    ...mapState({
      tituloTela: (state) => state.titulo_tela,
    }),

    total_documentos() {
      if (!this.documentos) {
        return 0;
      }
      
      return this.documentos.reduce((soma, documento) => { return soma + documento.valor_pago }, 0)
    },

    styleCardTotal() {
      return {
        'background-color': this.$vuetify.theme.themes.light.primary
      }
    },

    total_selecionado() {
      return this.selected.reduce((soma, item) => soma + Number(item.valor_restante), 0);
    }
    
  },

  async mounted() {
    this.setTitulo('Extrato do Fornecedor');

    console.log(this.$route.params.id);
    if (this.$route.params.id) {
      await this.pagamentosStore.carregarFornecedor(this.$route.params.id)
    }

    if (this.pagamentosStore.fornecedor.id) {
      Promise.all([
        this.carregarContasPagar(),
        this.carregarPagamentos()
      ]);
    }
  },

  methods: {
    ...mapMutations(['setTitulo', 'LOADING_OFF']),
    
    ...mapMutations('recebimentos', ['limparPromissorias', 'adicionarPromissoria']),
    ...mapActions('recebimentos', ['setCliente']),
    ...mapActions({
        abrirCliente: 'clientes/abrir'
      }),

    ...mapMutations('financeiro', ['limparlistas', types.SET_DRAWER_CLIENTES]),
    ...mapActions('financeiro', ['extratocliente', 'recebimentoDocumentos', 'cancelarPagamento', 'excluirPromissoria']),

    async onTabChange(tab) {
      console.log('onTabChange', tab);
      this.pagamentosStore.tab = tab;

      if (this.pagamentosStore.tab == 0 && this.pagamentosStore.contas_pagar_em_aberto.length == 0) {
        await this.carregarContasPagar();
      }

      if (this.pagamentosStore.tab == 1 && this.pagamentosStore.pagamentos_efetuados.length == 0) {
        await this.carregarPagamentos();
      }

      if (this.pagamentosStore.tab == 2) {
        await this.carregarHistoricoWhatsapp();
      }
    },

    async filtrarContasPagar(status) {
      this.pagamentosStore.btnStatus.contaspagar = status;

      this.carregarContasPagar();
    },

    async filtrar() {
      try {
        this.loading = true;
        await this.extratocliente(this.cliente.id);
        this.tab = 1;
        this.pagamentosStore.btnStatus.promissorias = 'abertos';
        if (this.recebimentos.length > 0) {
          this.selecionado = this.recebimentos[0];
          await this.recebimentoDocumentos(this.selecionado.id);
        }
      } catch (error) {
        this.$eventbus.erro('Não foi possível carregar o extrato do cliente', error)
      } finally {
        this.loading = false;
      }
      
    },

    dar_baixa(promissoria){
      if (this.selected.length > 0) {
        this.selected.forEach(selected => {
          this.pagamentosStore.adicionarContaPagar(this.clone(selected));
        })
      }

      // this.pagamentosStore.fornecedor = this.fornecedor;
      this.$router.push({ name: 'PagamentoFornecedor' });
    },

    cancelarSelecionados() {
      this.selected = [];
    },

    adicionarPromissoriaAvulsa() {
      this.$refs.form_promissoria.resetValidation();
      this.promissoria = {
        cliente_id: this.cliente.id,
        documento: '',
        forma_pagamento: 'Duplicata',
        vencimento: this.hoje(),
        valor: 0,
        observacao: ''
      },
      this.$refs.dialogoPromissoria.abrir();
      this.setFocus('documento');
    },

    async confirmarPromissoria() {
      try {
        this.salvando = true;
        this.promissoria.valor_restante = this.promissoria.valor;
        await this.$store.dispatch('financeiro/adicionarPromissoria', this.promissoria);
        this.$eventbus.notificar('Promissória salva com sucesso');
        this.$refs.dialogoPromissoria.fechar();
      } catch (error) {
        this.$eventbus.erro('Não foi possível salvar promissória', error);
      } finally {
        this.salvando = false;
      }
    },

    imprimirPedido(pedido) {
      this.$imprimir(`/pedidos/${pedido.id}/imprimir`, `pedido_${pedido.id}.pdf`);
      // this.abrirJanela(config.BASE_URL_PRINT + '/pedidos/'+ pedido.id +'/imprimir');
    },

    abrirPedido(promissoria) {
      this.abrirJanela(config.BASE_URL + '/#/vendas/pedidos/'+ promissoria.pedido_id +'/editar');
    },

    async selecionar(pagamento) {
      if (this.selecionado.id != pagamento.id) {
        this.loadingdocs = true;
        this.selecionado = pagamento;
        await this.pagamentosStore.pagamentoDocumentos(pagamento.id);
        this.tab_pagamentos = 0;
        this.loadingdocs = false;
      }
    },

    selecionarDocumento(props) {
      if (this.pagamentosStore.btnStatus.contaspagar == 'abertos') {
        props.select(!props.isSelected)
      }
    },

    exibirPagamentos(documento) {
      this.$refs.dialogoExibirPagamentos.abrir(documento);
    },

    async perguntarCancelarPagamento(pagamento) {
      // this.cancelando = true;
      this.pagamento = pagamento;
      let response = await this.$refs.dialogoCancelarPagamento.abrir();
      if (response == true) {
        this.confirmarCancelarPagamento();
      }
    },

    async confirmarCancelarPagamento() {

      try {
        this.cancelando = true;
        await this.cancelarPagamento(this.pagamento.id);
        // this.selecionado = this.recebimentos[0];
        // await this.recebimentoDocumentos(this.selecionado.id);
        this.$eventbus.notificar('Pagamento cancelado');
      } catch (error) {
        console.log(error);
        this.$eventbus.erro('Não foi possível cancelar o pagamento', error);
      } finally {
        this.cancelando = false;
        this.$refs.dialogoCancelarPagamento.fechar();
        await this.extratocliente(this.cliente.id);
      }

      
    },

    async excluir(contapagar) {
      this.$refs.dialogoRemoverPromissoria.abrir()
        .then(async response => {

          if (response == true) {

            try {
              this.$refs.dialogoRemoverPromissoria.startLoading();
              await this.contasPagarStore.excluir(contapagar);

              this.$refs.dialogoRemoverPromissoria.fechar();
              this.$eventbus.notificar("Conta excluída com sucesso.");
              this.pagamentosStore.listarContasPagar();
            } catch (error) {
              this.$eventbus.erro('Não foi possível excluir conta', error);
              throw error;
            } finally {
              this.$refs.dialogoRemoverPromissoria.stopLoading();
            }

          }

        })
    },

    selecionarFornecedor(fornecedor) {
      this.pagamentosStore.fornecedor = fornecedor;
      this.$refs.dialogoBuscarFornecedor.fechar();

      this.carregarContasPagar();
      this.carregarHistoricoWhatsapp();
    },

    async carregarContasPagar() {
      try {
        this.loading = true;
        await this.pagamentosStore.listarContasPagar();

      } catch (error) {
        this.$eventbus.erro('Não foi possível carregar as contas a pagar.', error)
      } finally {
        this.loading = false;
      }

      
    },

    async carregarPagamentos() {
      try {
        this.loading = true;
        await this.pagamentosStore.carregarPagamentosEfetuados();

      } catch (error) {
        this.$eventbus.erro('Não foi possível carregar os pagamentos efetuados.', error)
      } finally {
        this.loading = false;
      }

      
    },

    async carregarHistoricoWhatsapp() {
      await this.listasStore.fetchListas([
        queryBuilder()
          .select('id','datahora', 'celular', 'valor', 'chavepix_id', 'conta_id', 'cliente_nome', 'cliente_id', 'fornecedor_id')
          .from('RegistroWhatsapp')
          .where(`fornecedor_id=${this.pagamentosStore.fornecedor.id}`)
          .orderBy('-datahora')
          .build()
      ]);
    }
  },


  watch: {
    fornecedor(val, oldval) {
      if (val.id != oldval.id) {
        this.selected = [];
      }
    }
  }
};
</script>

<style scoped>

</style>

